import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'dl-resend-details',
  templateUrl: './resend-details.component.html',
  styleUrls: ['./resend-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ResendDetailsComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  public displayedColumns = this.data.columnData;
  public dataSource = new MatTableDataSource<any>();
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public tableData: any[] = this.data.tableData.selectedItems;
  public contactNotificationId: any[];
  public notificationId:any;

  constructor(
    public qnsbnService: QnSbnService, 
    public readonly oneSnackBar: OneSnackBarService, 
    public dialogRef: MatDialogRef<ResendDetailsComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any
  ){}

  public ngOnInit(): void {
    this.sort.sort(({ id: 'CustomerName', start: 'asc'}) as MatSortable);
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.tableData;
    this.contactNotificationId =  this.data.tableData.contactNotificationId;
    this.notificationId = this.data.tableData.notificationId;
  }

  public resend(){
    const resendApi = {
      NotificationId : this.notificationId,
      ContactNotificationIds: this.contactNotificationId
    }
    const resendJson= JSON.stringify(resendApi);
    this.qnsbnService.postResendNotifications(resendJson).subscribe(
      (data:any) => {
        this.oneSnackBar.open('Notification sent successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
        this.dialogRef.close();
      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Email id is either not verified or wrong. Please correct and try again later.');
      }
    );
  }
}
